import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.principal').factory('BrandSvc', BrandSvc);

    BrandSvc.$inject = [
        'BrandDA'
    ];

    /* @ngInject */
    function BrandSvc(
        BrandDA
    ) {
        var exports = {
            saveBrand: saveBrand,
            saveFile: saveFile
        };

        return exports;

        ////////////////

        /**
         * Création et Modification de la personalisation (Brand).
         */
        function saveBrand(brand) {
            return BrandDA.saveBrand(brand);
        }

        /**
         * Sauvegarder le fichier temporaire.
         */
        function saveFile(file) {
            return BrandDA.saveFile(file);
        }
    }
})();
